import React from 'react';
import { useAppSelector } from 'state/store';
import { currentReportSelector } from 'state/store/selectors';
import { ViewControlsProps } from '../types';
import './ViewControls.scss';

export const ViewControls: React.FC<ViewControlsProps> = ({
  children,
  showTitle = true,
}): JSX.Element => {
  const currentReport = currentReportSelector(useAppSelector((state) => state));

  return (
    <div className="view-controls">
      {showTitle && (
        <h2 className="view-controls__title">{currentReport?.name}</h2>
      )}
      <div className="view-controls__controls">{children}</div>
    </div>
  );
};
